module.exports = __webpack_public_path__ + "img/VI.6f4e038b.png";